import LocationSubscriptionAdapter from './location-subscription';

export default class ScopedSubscriptionAdapter extends LocationSubscriptionAdapter {
  pathForType() {
    return 'subscriptions/scoped';
  }
}
